import * as React from 'react';
import { Divider, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Summary = () => (
  <div>
    <Segment>
      <h3>Intro</h3>
      Some content here
      <Link className='button primary-button' to={{ pathname: '/application-form/intro' }}>
        Visit
      </Link>
      <Divider section={true} />
      <h3>Plan Holders</h3>
      Some content here
      <Link className='button primary-button' to={{ pathname: '/application-form/planholders' }}>
        Visit
      </Link>
      <Divider section={true} />
      <h3>Beneficiaries</h3>
      Some content here
      <Link className='button primary-button' to={{ pathname: '/application-form/beneficiaries' }}>
        Visit
      </Link>
      <Divider section={true} />
      <h3>Declarations</h3>
      Some content here
      <Link className='button primary-button' to={{ pathname: '/application-form/declarations' }}>
        Visit
      </Link>
    </Segment>
  </div>
)

export default Summary;